$(window).on("resize", function() {
	if ($(this).width() > 1200) {
		if (window.device == 'mobile') {
			location.reload()
		}
		window.device = 'desktop';
	} else {
		if (window.device == 'desktop') {
			location.reload()
		}
		window.device = 'mobile';
	}
}).trigger("resize")






$("#backtotop").on("click", function() {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: 0,
		ease: 'power2.inOut',
	});
})




$("#scrolldown").on("click", function() {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: $(window).height(),
		ease: 'power2.inOut',
	});
})






// 選單下滑隱藏 快滾回去時消失
var _scrollLast = 0

$(window).on("scroll", () => {
	var _scrollTop = $(window).scrollTop()
	var _allBottom = $("body").height() - $(window).height() - 100

	if (_scrollTop < 0 || _scrollTop > _allBottom) {
		return false;
	}

	if (_scrollTop > 200) {
		if (_scrollTop > _scrollLast) {
			$("#fixed-topmenuWrap").removeClass("is-show")
		} else {
			$("#fixed-topmenuWrap").addClass("is-show")
		}
	} else {
		$("#fixed-topmenuWrap").removeClass("is-show")
	}

	_scrollLast = _scrollTop
}).trigger("scroll")






class RyderMarquee {
	constructor(el, setting) {
		this.hero = $(el).parent().get(0)
		this.wrapper = el
		this.delta = 0
		this.transform = 0
		this.step = 0.5
		this.direct = 0
		this.hover = false
		this.isHover = false

		Object.assign(this, setting)

		if (device == 'mobile') {
			this.step /= 2
		}

		if (this.direct == 1) {
			this.wrapper.style.transform = `translate3d(-${this.wrapper.getBoundingClientRect().width / 2}px, 0, 0)`;
			this.transform = -this.wrapper.getBoundingClientRect().width / 2
		}

		if (this.hover) {
			$(el).hover(() => {
				this.isHover = true
			}, () => {
				this.isHover = false
			})
		}
	}

	animate() {
		if (!this.isHover) {
			this.transform += this.step
		}

		if (this.direct == 1) {
			if (this.transform > 0) {
				this.transform = -this.wrapper.getBoundingClientRect().width / 2;
			}
			this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
		} else {
			if (this.transform > this.wrapper.getBoundingClientRect().width / 2) {
				this.transform = 0;
			}
			this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
		}
	}

	render() {
		this.scrollY = $(window).scrollTop()

		const bounding = this.hero.getBoundingClientRect();
		const distance = (window.innerHeight + this.scrollY) - (bounding.top + this.scrollY);
		const percentage = distance / ((window.innerHeight + bounding.height) / 100);

		this.animate();
	}

	create() {
		gsap.ticker.add(this.render.bind(this));
	}
}


function marqueeHandler(el, d = 0, s = null) {
	var $copy = $(el).contents().clone();
	$(el).append($copy);

	var options = {
		direct: d
	};

	if (s !== null) {
		options.step = s;
	}

	var ryderMarquee = new RyderMarquee(el, options).create();
}






$("#preload").delay(500).fadeOut(500)







$("[data-from").each(function(i, el) {
	let _r = (device != 'mobile') ? el.dataset.from : el.dataset.from * 0.4
	let _p = $(window).width() / 2 * _r

	gsap.fromTo(el, {
		x: `${-_p}px`,
	}, {
		scrollTrigger: {
			trigger: el,
			start: `top 100%`,
			end: `center 40%`,
			scrub: 0.8,
			// markers: true,
		},
		x: 0,
		ease: "none",
	});
})





function checkAnchor(id) {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: {
			y: `#${id}`,
			// offsetY: $(window).height() * 0.2,
		},
		ease: 'power2.inOut',
		onComplete: function() {
			history.pushState("", document.title, window.location.pathname);
		}
	});
}





let observer = new IntersectionObserver(function(entries, observer) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.classList.add('is-enter');
		} else {
			// entry.target.classList.remove('is-enter');
		}
	});
}, {
	root: null, // 表示要觀察的根元素為視窗
	threshold: 0 // 表示元素只要有一點進入視窗就觸發
});


$(window).on("load", function() {
	// ryder特製anchor定位
	const _now = location.href.split("#")[0].split("/").slice(-1);
	let anchor = location.href.split("#")[1]

	if (anchor != undefined) {
		checkAnchor(anchor)
	}

	$("a").not("[href='javascript:;']").not("[href^='tel:']").not("[href^='mailto:']").not("[target='_blank']").not("[data-fancybox]").not("[data-share]").on("click", function(e) {
		e.preventDefault()

		let page = $(this).attr('href').split("#")[0].split("/").slice(-1);
		let anchor = $(this).attr('href').split("#")[1]

		if (_now[0] == page[0]) {
			// 同一頁不跳頁用滾的
			e.preventDefault()
			checkAnchor(anchor)
		} else {
			// 不同頁
			$(".loader-gradient").removeClass("is-hide")

			$("#preload").fadeIn(300, () => {
				location.href = $(this).attr('href')
			})
		}
	})




	$("[data-enter]").each((i, el) => {
		observer.observe(el);
	});


	$(".loader-gradient").addClass("is-hide")






	$(".ryder-split").each(function(i, el) {
		gsap.from(new SplitText($(el)).chars, {
			scrollTrigger: {
				trigger: el,
				start: "top 80%",
				end: "bottom 50%",
				toggleActions: "play none none none",
			},
			delay: 0.3,
			duration: 2,
			opacity: 0,
			stagger: {
				each: .067,
			},
			ease: "circle.out",
			onUpdate: function() { }
		});
	})
})







Fancybox.bind('[data-fancybox]', {
	Toolbar: {
		enabled: true,
		parentEl: function() {
			return this.instance.container?.querySelector(".fancybox__footer") || null;
		},
		items: {
			close: {
				tpl: '<button class="f-button fancy-close" title="{{CLOSE}}" data-fancybox-close><img src="images/fancy-close.svg" class="basic-hover"></button>',
			},
		},
		display: {
			left: [],
			middle: ["close"],
			right: [],
		},
	},
});